import { IoSavedSearch, Row } from '@cloudio-saas/datasource-types';
import { atom, Path } from '@cloudio-saas/statex';
import { ClientFilter } from 'components/SmartSearch/types';

export const searchEntriesAtom = atom<ClientFilter[]>({
  path: ['ui', 'smartSearch', ':appUid', ':pageId', ':itemId', 'filters'],
  defaultValue: [],
});

export const searchQueriesAtom = atom<Row<IoSavedSearch>[]>({
  path: ['ui', 'smartSearch', ':appUid', ':pageId', ':itemId', 'queries'],
  defaultValue: [],
});

export const activeQueryAtom = atom<string>({
  path: ['ui', 'smartSearch', ':appUid', ':pageId', ':itemId', 'activeQuery'],
  defaultValue: '',
});

export const activeQueryNameAtom = atom<string | undefined>({
  path: [
    'ui',
    'smartSearch',
    ':appUid',
    ':pageId',
    ':itemId',
    'activeQueryName',
  ],
  defaultValue: '',
});

export const lastActiveQueryAtom = atom<string>({
  path: [
    'ui',
    'smartSearch',
    ':appUid',
    ':pageId',
    ':itemId',
    'lastActiveQuery',
  ],
  defaultValue: '',
});

export const searchUpdateAtom = atom<boolean>({
  path: ['ui', 'smartSearch', ':appUid', ':pageId', ':itemId', 'isUpdate'],
  defaultValue: false,
});

export const searchRecordAtom = atom<Partial<IoSavedSearch>>({
  path: [
    'ui',
    'smartSearch',
    'db',
    ':appUid',
    ':pageId',
    ':itemId',
    'searchRecord',
  ],
  defaultValue: {},
});

export const editPathAtom = atom<Path>({
  path: [
    'ui',
    'smartSearch',
    'transient',
    ':appUid',
    ':pageId',
    ':itemId',
    'editPath',
  ],
  defaultValue: [],
});

export const editingAtom = atom<boolean>({
  path: [
    'ui',
    'smartSearch',
    'transient',
    ':appUid',
    ':pageId',
    ':itemId',
    'editing',
  ],
  defaultValue: false,
});

export const editingEntryAtom = atom<ClientFilter | undefined>({
  path: [
    'ui',
    'smartSearch',
    'transient',
    ':appUid',
    ':pageId',
    ':itemId',
    'editingEntry',
  ],
  defaultValue: undefined,
});

type INIT_VALUES =
  | 'INIT'
  | 'INIT_FETCHED'
  | 'ACTIVE_QUERY_CHANGE'
  | 'FETCH_REQUEST'
  | 'FETCHED'
  | 'CLEAR_VIEW'
  | 'ALL_SET';

export const initAtom = atom<INIT_VALUES>({
  path: [
    'ui',
    'smartSearch',
    'transient',
    ':appUid',
    ':pageId',
    ':itemId',
    'init',
  ],
  defaultValue: 'INIT',
});

export const attributesAtom = atom<string>({
  path: [
    'ui',
    'smartSearch',
    'transient',
    ':appUid',
    ':pageId',
    ':itemId',
    'attributes',
  ],
  defaultValue: '',
});

export const gridSmartSearchAtom = atom<string>({
  path: [
    'ui',
    'smartSearch',
    'transient',
    ':appUid',
    ':pageId',
    ':itemId',
    'smartSearchId',
  ],
  defaultValue: '',
});

export const smartSearchUpdateAtom = atom<boolean>({
  path: [
    'ui',
    'smartSearch',
    'transient',
    ':appUid',
    ':pageId',
    ':itemId',
    'updateNeeded',
  ],
  defaultValue: false,
});
